import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
  padding-right: 40px;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const ContentDiv = styled.div`
  padding: 0 2.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const FormBody = styled.div`
  padding: 0 1.375rem;
`;

export const OuterWrapperBackground = styled.div`
    background: #f5f5f5 !important;
}`;

export const PaddingDiv = styled.div`
  box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 20%);
  background-color: white;
}`;

export const OuterWrapper = styled.div`
  padding: 1.375rem;
}`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: 10px;
`;

export const ComponentContainer = styled.div`
  height: 120px;
  overflow: auto;
  margin-bottom: 5px;
`;

export const ErrorLabel = styled.span`
  font-weight: bold;
  color: red;
  font-style: italic;
  float: left;
`;

export const CheckboxGridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  column-gap: 10px;
`;

export const ContainerLabel = styled.label`
  width: auto;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  text-align: center;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const MarginDiv = styled.div`
  margin-top: 15px;
  margin-bottom: 20px;
`;

export const ErrorDiv = styled.div`
  height: auto;
  border: solid 1px red;
  padding: 7px;
`;

export const ErrorLog = styled.div`
  margin: 10px;
`;

export const MarginBottom = styled.div`
  margin-bottom: 15px;
`;
